<template>
  <div
    :class="{
      'hidden lg:flex items-center gap-2 ml-auto ': isHeader,
      'lg:hidden flex flex-col gap-2': !isHeader,
    }"
  >
    <router-link
      to="/bridge"
      class="button-primary sm:hidden flex items-center justify-center text-white font-bold gap-3 rounded-xl whitespace-nowrap text-xs py-2 px-3"
    >
      Bridge
    </router-link>
    <div class="flex items-center w-full gap-2">
      <a
        href="https://etherscan.io/token/0x85225ed797fd4128ac45a992c46ea4681a7a15da"
        target="_blank"
      >
        <img
          src="/svg/etherscan-circle.svg"
          alt=""
          :class="{
            'h-9 w-9': isHeader,
            'h-7 w-7': !isHeader,
          }"
        />
      </a>
      <NetworkSelect />
    </div>

    <div class="flex items-center w-full gap-2">
      <router-link
        to="/bridge"
        class="button-primary sm:flex hidden items-center justify-center text-white font-bold gap-3 rounded-xl w-full whitespace-nowrap text-xs py-2 px-3"
      >
        Bridge
      </router-link>
      <Button
        text="Read Docs"
        type="link"
        link="https://docs.hyperbolicprotocol.com"
        primary
        small
        :full="!isHeader"
      />
      <Button
        v-if="!isConnected"
        @click="init"
        text="Connect Wallet"
        secondary
        small
        :full="!isHeader"
      />
      <Button
        v-if="isConnected"
        @click="disconnect"
        text="Disconnect Wallet"
        danger
        small
        :full="!isHeader"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Button from "./Button.vue";
import NetworkSelect from "../network/NetworkSelect.vue";
export default {
  name: "SidebarActions",
  components: {
    Button,
    NetworkSelect,
  },
  props: {
    isHeader: { type: Boolean, default: true },
  },
  computed: {
    ...mapGetters([
      "isConnected",
      "userAddress",
      "openMobileSidebar",
    ]),
  },
  methods: {
    ...mapActions(["init", "disconnect"]),
  },
};
</script>
